import React from "react";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Color } from "../../Form/Button";
import Modal from "../../Generic/Modal";
import useStyles from "./styles";
import { PortalProps } from "@mui/material";

interface Props {
  open: boolean;
  title: string;
  children: React.ReactNode;
  loading?: boolean;
  closeModal?: () => void;
  submit?: () => void;
  iconDivClass?: string;
  textSubmit?: string;
  leftIconTitle?: JSX.Element;
  customColorCancel?: Color;
  customColorSave?: Color;
  textCancel?: React.ReactNode;
  type?: "error" | "alert" | "success" | "warning" | "info";
  showCancelButton?: boolean;
  saveDisabled?: boolean;
  width?: string;
  maxWidth?: string;
  cancelDisabled?: boolean;
  className?: React.HTMLAttributes<unknown>["className"];
  cancelClassName?: React.HTMLAttributes<unknown>["className"];
  saveClassName?: React.HTMLAttributes<unknown>["className"];
  modalFooterCustomClass?: string;
  container?: PortalProps["container"] | undefined;
}

const ConfirmationModal = ({
  container,
  open,
  title,
  loading,
  children,
  closeModal,
  submit,
  textSubmit,
  leftIconTitle,
  iconDivClass,
  customColorCancel,
  customColorSave,
  textCancel,
  type = "success",
  showCancelButton = true,
  saveDisabled = false,
  width,
  maxWidth,
  cancelDisabled,
  className,
  cancelClassName,
  saveClassName,
  modalFooterCustomClass,
}: Props) => {
  const { t: translate } = useTranslation();

  const classes = useStyles({ type, width, maxWidth });

  const renderTitle = () => {
    return (
      <div className={classes.title}>
        {leftIconTitle && (
          <div className={classNames(classes.iconDiv, iconDivClass)}>{leftIconTitle}</div>
        )}

        <span data-cy="confirmationModalTitle">{title}</span>
      </div>
    );
  };

  return (
    <Modal
      container={container}
      open={open}
      className={classNames(classes.mainDialog, className)}
      handleClose={closeModal}
      title={renderTitle()}
      showActionButtons
      actionButtonProps={{
        onCancel: showCancelButton ? closeModal : undefined,
        customColorCancel: customColorCancel || undefined,
        customColorSave: customColorSave || undefined,
        textCancel: textCancel || translate("cancel"),
        cancelDisabled: cancelDisabled || undefined,
        onSave: submit,
        textSave: textSubmit || translate("save"),
        loading,
        saveDisabled,
        classesSave: saveClassName,
        classesCancel: cancelClassName,
      }}
      modalFooterCustomClass={modalFooterCustomClass}
    >
      {children}
    </Modal>
  );
};

export default ConfirmationModal;
